namespace advisorop.components.common {

    class AlertDashboardController {

        $router;
        panelTitle: string;
        showUserEntry: boolean = false;
        showTasksWorkflow: boolean = false;
        showRsikMonitorAlerts: boolean = false;

        static $inject = ["identityService"];
        constructor(public identityService: services.IdentityService) {

        }

        logout(): void {
            this.identityService.logout();
        }
        
        showUserEntryAlerts(showUserEntry: boolean): void {
            this.showUserEntry = showUserEntry;
            this.showTasksWorkflow = false;
            this.showRsikMonitorAlerts = false;
            this.panelTitle = "Service requests";
        }

        showWorkflowTasks(showWfTask: boolean): void {
            this.showTasksWorkflow = showWfTask;
            this.showUserEntry = false;
            this.showRsikMonitorAlerts = false;
            this.panelTitle = "Workflow tasks and alerts";
        }

        showRiskMonitorTasks(showRiskMonitorTasks: boolean): void {
            this.showRsikMonitorAlerts = showRiskMonitorTasks;
            this.showUserEntry = false;
            this.showTasksWorkflow = false;
            this.panelTitle = "RISK MONITOR ALERTS";
        }

        showAllAlerts(): void {
            this.showUserEntry = false;
            this.showTasksWorkflow = false;
            this.showRsikMonitorAlerts = false;
            this.panelTitle = "TASKS AND ALERTS";
        }

        $onInit(): void {
        }

        $routerOnActivate(next, previous) {
            if (next.params.showUserentry) {
                this.showUserEntryAlerts(<boolean>next.params.showUserentry);
            } else if (next.params.showWfTask) {
                this.showWorkflowTasks(<boolean>next.params.showWfTask);
            } else if (next.params.showRsikMonitorAlerts) {
                this.showRiskMonitorTasks(<boolean>next.params.showRsikMonitorAlerts);
            } else {
                // show all alerts
                this.showAllAlerts();
            }
        }

    }



    class AlertDashboard implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                $router: "<"
            };
            this.controller = AlertDashboardController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/alert-dashboard.html';
        }
    }

    angular.module(Constants.APP).component("alertDashboard", new AlertDashboard());
}